export class NotificationModel {
  public id: string;
  public userId: number;
  public type: NotificationType;
  public linkId: number;
  public reportNo: string;
  public queryParameter: string;
  public message: string;
  public typeLabel: string;
  public link: string;
  public iconName: string;
  public isRead: boolean;
  public dateType: NotifactionDateType;
  designNumber: any;
}

export enum NotificationType {
  LeaveApproved = 1,
  LeaveRejected = 2,
  ExpenseApproved = 3,
  ExpenseChecked = 4,
  ExpensePaid = 5,
  ExpenseRejected = 6,
  LeaveApprovedHrLeave = 7,
  LeaveCancelled = 8,
  ExpenseCancelled = 9,
  InspectionRequested = 10,
  InspectionConfirmed = 11,
  InspectionCancelled = 12,
  InspectionModified = 13,
  InspectionScheduled = 14,
  InspectionRescheduled = 15,
  InspectionSplit = 16,
  QuotationAdd = 17,
  QuotationToApprove = 18,
  QuotationSent = 19,
  QuotationCustomerConfirmed = 20,
  QuotationCustomerReject = 21,
  QuotationCanceled = 22,
  QuotationRejected = 23,
  QuotationModified = 24,
  BookingQuantityChange = 25,
  BookingReportValidated = 26,
  InspectionHold = 27,
  InspectionReportValidated = 28,
  AuditRequested = 29,
  AuditConfirmed = 30,
  AuditCancelled = 31,
  AuditScheduled = 32,
  AuditRescheduled = 33,
  AuditReportValidated = 34,
  AutoInspectionCertificate = 35,
  PimAttributes = 36,
  PimBillOfMaterials = 37,
  PimTestingStandard = 38,
  PimDocuments = 39,
  Vendor = 40,
  PO = 41,
  BookingComment = 42,
  AuditComment = 43,
  NewLabbooking =44,
  LabSampleDispatched = 45,
  LabSampleReceived =46,
  LabReportAvailable = 47,
  CustomerDecision =48,
  LabBookingComment = 49,
  LabReportComment = 50,
  LabBookingCancel = 51,
  LabReportInvalidated = 52,
  AwaitingForApproval = 53,
  BSQSubmittedAwaitingForApproval = 55,
  BrandAdded = 56,
  AgentDocumentStageCompleted = 57,
  AgentStageCompletedBySupplier = 58,
  DocumentAcknowledge = 59,
  AwaitingForDocumentApproval = 60,
  UserStageCompleted = 63,
  AgentStageCompleted = 64,
  ManagerStageCompleted = 65,
  DocumentStageCompleted = 66,
  LaunchedStageCompleted = 71,
  ApprovedByOperationManager = 72,
  RejectedByOperationManager = 73,
  ApprovedByCustomerServiceManager = 74,
  RejectedByCustomerServiceManager = 75,
  ApprovedByProductManager = 76,
  RejectedByProductManager = 77,
  ApprovedByTechnologist = 78,
  RejectedByTechnologist = 79,
  ApprovedByTechnologyManager = 80,
  RejectedByTechnologyManager = 81,
  DocumentApprovedByOperation = 82,
  DocumentRejectedByOperation=83,
  AgentDocumentSent=84,
  ModelCodeAdded =85,
  PLMSupplier = 86,
  PLMCustomer=87,
}

export class NotificationResponse {
  public result: NotificationResult;
  public data: Array<NotificationModel>;
}

export enum NotificationResult {
  Success = 1,
  NotFound = 2
}
export class NotificationSearchRequest {
  public skip: number;
  public isRead?: boolean;
  public notificationType?: NotificationFilterType;
}
export class NotificationMessage {

  constructor(n: NotificationModel, m: string, l: string, ln: number, r: string, q: string, i: string) {
    this.notification = n;
    this.message = m;
    this.link = l;
    this.linkId = ln;
    this.reportNo = r;
    this.queryParameter = q;
    this.iconName = i;
  }
  public message: string;
  public notification: NotificationModel;
  public link: string;
  public linkId: number;
  public reportNo: string;
  public queryParameter: string;
  public iconName: string;
}
export enum NotifactionDateType {
  Today = 1,
  Yesterday = 2,
  Older = 3
}
export enum NotificationFilterType {
  Inspection = 1,
  Audit = 2,
  InspectionReport = 3,
  AuditReport = 4,
  PIM = 5,
  VendorComment = 6,
  PurchsaseOrderComment = 7,
  InspectionBookingComment =8,
  AuditBookingComment = 9,
  LabOrder = 10,
  LabBookingComment = 11,
  LabReportComment = 12,
  PLMCooment = 13
}
